<template>
<div class="chapter">
<div class="inner_page">
<h2 class="calibre" id="pgepubid00003">
      CHAPTER I
    </h2>
<p class="calibre3">
      Mayday afternoon in Oxford Street, and Felix Freeland, a little late, on
      his way from Hampstead to his brother John's house in Porchester Gardens.
      Felix Freeland, author, wearing the very first gray top hat of the season.
      A compromise, that—like many other things in his life and works—between
      individuality and the accepted view of things, aestheticism and fashion,
      the critical sense and authority. After the meeting at John's, to discuss
      the doings of the family of his brother Morton Freeland—better known
      as Tod—he would perhaps look in on the caricatures at the English
      Gallery, and visit one duchess in Mayfair, concerning the George Richard
      Memorial. And so, not the soft felt hat which really suited authorship,
      nor the black top hat which obliterated personality to the point of pain,
      but this gray thing with narrowish black band, very suitable, in truth, to
      a face of a pale buff color, to a moustache of a deep buff color streaked
      with a few gray hairs, to a black braided coat cut away from a
      buff-colored waistcoat, to his neat boots—not patent leather—faintly
      buffed with May-day dust. Even his eyes, Freeland gray, were a little
      buffed over by sedentary habit, and the number of things that he was
      conscious of. For instance, that the people passing him were distressingly
      plain, both men and women; plain with the particular plainness of those
      quite unaware of it. It struck him forcibly, while he went along, how very
      queer it was that with so many plain people in the country, the population
      managed to keep up even as well as it did. To his wonderfully keen sense
      of defect, it seemed little short of marvellous. A shambling, shoddy crew,
      this crowd of shoppers and labor demonstrators! A conglomeration of
      hopelessly mediocre visages! What was to be done about it? Ah! what
      indeed!—since they were evidently not aware of their own dismal
      mediocrity. Hardly a beautiful or a vivid face, hardly a wicked one, never
      anything transfigured, passionate, terrible, or grand. Nothing Greek,
      early Italian, Elizabethan, not even beefy, beery, broad old Georgian.
      Something clutched-in, and squashed-out about it all—on that
      collective face something of the look of a man almost comfortably and
      warmly wrapped round by a snake at the very beginning of its squeeze. It
      gave Felix Freeland a sort of faint excitement and pleasure to notice
      this. For it was his business to notice things, and embalm them afterward
      in ink. And he believed that not many people noticed it, so that it
      contributed in his mind to his own distinction, which was precious to him.
      Precious, and encouraged to be so by the press, which—as he well
      knew—must print his name several thousand times a year. And yet, as
      a man of culture and of principle, how he despised that kind of fame, and
      theoretically believed that a man's real distinction lay in his oblivion
      of the world's opinion, particularly as expressed by that flighty
      creature, the Fourth Estate. But here again, as in the matter of the gray
      top hat, he had instinctively compromised, taking in press cuttings which
      described himself and his works, while he never failed to describe those
      descriptions—good, bad, and indifferent—as 'that stuff,' and
      their writers as 'those fellows.'
    </p>
<p class="calibre3">
      Not that it was new to him to feel that the country was in a bad way. On
      the contrary, it was his established belief, and one for which he was
      prepared to furnish due and proper reasons. In the first place he traced
      it to the horrible hold Industrialism had in the last hundred years laid
      on the nation, draining the peasantry from 'the Land'; and in the second
      place to the influence of a narrow and insidious Officialism, sapping the
      independence of the People.
    </p>
<p class="calibre3">
      This was why, in going to a conclave with his brother John, high in
      Government employ, and his brother Stanley, a captain of industry,
      possessor of the Morton Plough Works, he was conscious of a certain
      superiority in that he, at all events, had no hand in this paralysis which
      was creeping on the country.
    </p>
<p class="calibre3">
      And getting more buff-colored every minute, he threaded his way on, till,
      past the Marble Arch, he secured the elbow-room of Hyde Park. Here groups
      of young men, with chivalrous idealism, were jeering at and chivying the
      broken remnants of a suffrage meeting. Felix debated whether he should
      oppose his body to their bodies, his tongue to theirs, or whether he
      should avert his consciousness and hurry on; but, that instinct which
      moved him to wear the gray top hat prevailing, he did neither, and stood
      instead, looking at them in silent anger, which quickly provoked
      endearments—such as: “Take it off,” or “Keep it on,” or “What cheer,
      Toppy!” but nothing more acute. And he meditated: Culture! Could culture
      ever make headway among the blind partisanships, the hand-to-mouth
      mentality, the cheap excitements of this town life? The faces of these
      youths, the tone of their voices, the very look of their bowler hats,
      said: No! You could not culturalize the impermeable texture of their
      vulgarity. And they were the coming manhood of the nation—this
      inexpressibly distasteful lot of youths! The country had indeed got too
      far away from 'the Land.' And this essential towny commonness was not
      confined to the classes from which these youths were drawn. He had even
      remarked it among his own son's school and college friends—an
      impatience of discipline, an insensibility to everything but excitement
      and having a good time, a permanent mental indigestion due to a permanent
      diet of tit-bits. What aspiration they possessed seemed devoted to
      securing for themselves the plums of official or industrial life. His boy
      Alan, even, was infected, in spite of home influences and the atmosphere
      of art in which he had been so sedulously soaked. He wished to enter his
      Uncle Stanley's plough works, seeing in it a 'soft thing.'
    </p>
<p class="calibre3">
      But the last of the woman-baiters had passed by now, and, conscious that
      he was really behind time, Felix hurried on....
    </p>
<p class="calibre3">
      In his study—a pleasant room, if rather tidy—John Freeland was
      standing before the fire smoking a pipe and looking thoughtfully at
      nothing. He was, in fact, thinking, with that continuity characteristic of
      a man who at fifty has won for himself a place of permanent importance in
      the Home Office. Starting life in the Royal Engineers, he still preserved
      something of a military look about his figure, and grave visage with
      steady eyes and drooping moustache (both a shade grayer than those of
      Felix), and a forehead bald from justness and knowing where to lay his
      hand on papers. His face was thinner, his head narrower, than his
      brother's, and he had acquired a way of making those he looked at doubt
      themselves and feel the sudden instability of all their facts. He was—as
      has been said—thinking. His brother Stanley had wired to him that
      morning: “Am motoring up to-day on business; can you get Felix to come at
      six o'clock and talk over the position at Tod's?” What position at Tod's?
      He had indeed heard something vague—of those youngsters of Tod's,
      and some fuss they were making about the laborers down there. He had not
      liked it. Too much of a piece with the general unrest, and these new
      democratic ideas that were playing old Harry with the country! For in his
      opinion the country was in a bad way, partly owing to Industrialism, with
      its rotting effect upon physique; partly to this modern analytic
      Intellectualism, with its destructive and anarchic influence on morals. It
      was difficult to overestimate the mischief of those two factors; and in
      the approaching conference with his brothers, one of whom was the head of
      an industrial undertaking, and the other a writer, whose books, extremely
      modern, he never read, he was perhaps vaguely conscious of his own cleaner
      hands. Hearing a car come to a halt outside, he went to the window and
      looked out. Yes, it was Stanley!...
    </p>
<p class="calibre3">
      Stanley Freeland, who had motored up from Becket—his country place,
      close to his plough works in Worcestershire—stood a moment on the
      pavement, stretching his long legs and giving directions to his chauffeur.
      He had been stopped twice on the road for not-exceeding the limit as he
      believed, and was still a little ruffled. Was it not his invariable
      principle to be moderate in speed as in all other things? And his feeling
      at the moment was stronger even than usual, that the country was in a bad
      way, eaten up by officialism, with its absurd limitations of speed and the
      liberty of the subject, and the advanced ideas of these new writers and
      intellectuals, always talking about the rights and sufferings of the poor.
      There was no progress along either of those roads. He had it in his heart,
      as he stood there on the pavement, to say something pretty definite to
      John about interference with the liberty of the subject, and he wouldn't
      mind giving old Felix a rap about his precious destructive doctrines, and
      continual girding at the upper classes, vested interests, and all the rest
      of it. If he had something to put in their place that would be another
      matter. Capital and those who controlled it were the backbone of the
      country—what there was left of the country, apart from these d—d
      officials and aesthetic fellows! And with a contraction of his straight
      eyebrows above his straight gray eyes, straight blunt nose, blunter
      moustaches, and blunt chin, he kept a tight rein on his blunt tongue, not
      choosing to give way even to his own anger.
    </p>
<p class="calibre3">
      Then, perceiving Felix coming—'in a white topper, by Jove!'—he
      crossed the pavement to the door; and, tall, square, personable, rang the
      bell.
    </p>
<p class="calibre3">
<a id="link2HCH0002">
</a>
</p>
<div class="pg-boilerplate" id="calibre_pb_7"></div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Section0003.vue?2bb3f65c